module.exports = function () {
  this.app.$on('getCards', event => {
    // Guests have empty credit cards
    if (!this.session.hasAuthenticatedUser()) {
      console.warn('no authenticated user', this.session.hasAuthenticatedUser(), this.session.token, this.session._token)
      this.app.$emit('getCardsSuccess', [])
      return
    }

    this.sdk.get('/me/cards?token=' + this.session.token, {}, res => {
      if (res.success) {
        this.app.cards = res.data
        this.app.$emit('getCardsSuccess', res.data)
      } else {
        this.app.$emit('getCardsFail', res)
      }
    })
  })
}



// WEBPACK FOOTER //
// ./src/events/get-cards.js